import ModuleWindowControls from '@/components/mosaic/ModuleWindowControl';
import useLanguage from '@/utils/hooks/useLanguage';
import { tabIcon } from '@/utils/hooks/useXplorSpotLayout';
import { xplorTraderTabIcon } from '@/utils/hooks/useXplorTraderLayout';
import ModuleWindow, { moduleHeaderClassName } from './ModuleWindow';

const tabIcons = { ...tabIcon, ...xplorTraderTabIcon };

const FeatureModule = (props: any) => {
    const { tradingModule } = props;

    const lang = useLanguage();

    return (
        <ModuleWindow
            {...props}
            renderToolbar={() => (
                <div className={moduleHeaderClassName} dir={lang.dir}>
                    <div className="h-full flex items-center p-2 gap-2">
                        {tabIcons[tradingModule?.key || ''] && (
                            <div className="flex items-center justify-center bg-brand-neutral-700 rounded-full p-1">
                                {tabIcons[tradingModule?.key || '']({
                                    className: 'w-4 h-4',
                                    'aria-hidden': true
                                })}
                            </div>
                        )}
                        <span className="font-semibold whitespace-nowrap">{tradingModule?.title}</span>
                    </div>
                    <ModuleWindowControls {...props} />
                </div>
            )}>
            {tradingModule?.component}
        </ModuleWindow>
    );
};

export default FeatureModule;
